import {ValueObject} from '@s-ui/domain'

import {SpecificationsVehiclesValueObject} from './SpecificationsVehiclesValueObject.js'

export class MakesWithModelsListVehiclesValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static empty() {
    return new MakesWithModelsListVehiclesValueObject({value: []})
  }

  static createFromLiterals({value}) {
    if (!Array.isArray(value)) return MakesWithModelsListVehiclesValueObject.empty()

    const vehicles = value.map(({id, label, models}) =>
      SpecificationsVehiclesValueObject.createFromMakeWithModels({makeId: id, makeName: label, models})
    )

    return new MakesWithModelsListVehiclesValueObject({value: vehicles})
  }

  get value() {
    return this.#value.map(vehicle => vehicle.value)
  }
}
